/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Extent specified either in geojson, wkt or ewkt. Coordinates in longitude, latitude order.
 * @export
 * @interface Extent1
 */
export interface Extent1 {
  /**
   * Type should always be 'Linestring'
   */
  type: string;
  /**
   * Exactly 2 coordinates, specifying the bottom left (longitude, latitude order) and upper right respectively
   */
  coordinates: Array<Array<number>>;
}

/**
 * Check if a given object implements the Extent1 interface.
 */
export function instanceOfExtent1(value: object): value is Extent1 {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function Extent1FromJSON(json: any): Extent1 {
  return Extent1FromJSONTyped(json, false);
}

export function Extent1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Extent1 {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function Extent1ToJSON(json: any): Extent1 {
  return Extent1ToJSONTyped(json, false);
}

export function Extent1ToJSONTyped(
  value?: Extent1 | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
